define('TescoMobile_Checkout/js/view/subscription-details',['Magento_Ui/js/form/form', 'Magento_Checkout/js/model/quote', 'Magento_Checkout/js/model/step-navigator', 'TescoMobile_Checkout/js/action/subscription-details', 'mage/translate', 'ko', 'underscore', 'jquery', 'uiRegistry'], function (Component, quote, stepNavigator, subscriptionDetails, $t, ko, _, $, registry) {
  'use strict';

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/subscription-details'
    },
    visible: false,
    phoneNameChangeTriggered: false,
    initialize: function () {
      this._super();
      var self = this;
      if (quote.getItems().length > 1) {
        stepNavigator.registerStep('subscription-details', 'subscription-details', $t('Subscription Details'), this.visible, _.bind(this.navigate, this), this.sortOrder);
      }
      this.visible.subscribe(function (value) {
        if (value === true) {
          if (this.phoneNameChangeTriggered === false) {
            this.phoneNameChangeTriggered = true;
            this.amendPhoneNickname();
          }
        }
      }.bind(this));
    },
    initObservable: function () {
      this._super().observe(['visible']);
      return this;
    },
    navigate: function (step) {
      step && step.isVisible(true);
    },
    setSubscriptionDetails: function () {
      var _this$source$get;
      var self = this;
      this.source.set('params.invalid', false);
      const formFields = (_this$source$get = this.source.get('subscription_details.subscription_names')) !== null && _this$source$get !== void 0 ? _this$source$get : [];
      if (formFields) {
        _.each(formFields, function (value, key) {
          self.source.trigger('subscription_names.' + key + '.data.validate');
        });
      }
      if (!this.source.get('params.invalid')) {
        const messageContainer = registry.get('checkout.errors').messageContainer;
        messageContainer.clear();
        var formData = this.source.get('subscription_details');
        subscriptionDetails(formData).fail(function (response) {
          var _response$responseJSO;
          if (response !== null && response !== void 0 && (_response$responseJSO = response.responseJSON) !== null && _response$responseJSO !== void 0 && _response$responseJSO.errors) {
            _.each(response.responseJSON.errors, function (value) {
              messageContainer.addErrorMessage(value);
            });
          } else {
            messageContainer.addErrorMessage(response.responseJSON);
          }
        }).done(function () {
          stepNavigator.next();
        });
      }
    },
    amendPhoneNickname: function () {
      var customerName,
        subscriptions,
        subscriptionNames = {};
      if (quote.firstName) {
        customerName = quote.firstName + 's';
        registry.async('checkoutProvider')(function (checkoutProvider) {
          subscriptions = Object.entries(checkoutProvider.get('subscription_details.subscription_names'));
          subscriptions.map(function (item) {
            subscriptionNames[item[0]] = customerName + ' ' + item[1];
          });
          checkoutProvider.set('subscription_details.subscription_names', subscriptionNames);
        });
      }
    }
  });
});

